import { memo } from 'react';
import Styles from './Body.module.scss';

const Header = ({ children }) => {
  return <div className={Styles.body}>{children}</div>;
};

export default memo(Header);
